export default class TravelLog {

    constructor()
    {
        window.addEventListener( 'save_bookmarks', function ( e ) {

            let count_all_bookmark = 0;

            for ( const [key, value] of Object.entries( e.detail.datas.items ) ) {
                count_all_bookmark = count_all_bookmark + value.length;
            }

            if ( count_all_bookmark === 0 ) {
                if ( !$( '.iris-travel-logGo-to-bookmarks-listsNumber' ).hasClass( 'hide' ) ) {
                    $( '.iris-travel-logGo-to-bookmarks-listsNumber' ).addClass( 'hide' );
                }
            } else {
                $( '.iris-travel-logGo-to-bookmarks-listsNumber' ).removeClass( 'hide' );
            }
        } );

        window.addEventListener( 'add_bookmark', function(e) {
            TravelLog.button_add_to_bookmark(e);
        } );
    }

    static button_add_to_bookmark(e)
    {
        let identifiant = e.detail.datas;
        let $trigger = $('[data-id-object="'+identifiant+'"]');

        $trigger.addClass( 'success' );
    }

}
